
// decorator
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

// mixins
import ResizeMixin from '../mixins/resize'
import ChartRenderMixin from '../ccg/mixins/ChartRenderMixin'

@Component({
  name: 'DoubleBarChart'
})
export default class extends mixins(ResizeMixin, ChartRenderMixin) {
  created() {
    this.BASE_CONFIG = {
      legend: {
        textStyle: {
          color: '#fff'
        }
      },
      grid: {
        top: '15%',
        left: '5%',
        right: '5%',
        bottom: '5%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        axisTick: {
          alignWithLabel: true
        },
        axisLine: {
          lineStyle: {
            color: '#999'
          }
        },
        splitLine: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        axisLine: {
          show: false,
          lineStyle: {
            color: '#999'
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#999'
          }
        }
      }
    }
  }
}
